import { geralSchema as gridSchema } from './gridSchema'
import { geralSchema as groupSchema } from './groupSchema'
import { geralSchema as groupDescriptionSchema } from './groupDescriptionSchema'
import { geralSchema as flexSchema } from './flexButtonsSchema';
export const schemas = {
  grid: gridSchema,
  group: groupSchema,
  groupDescription: groupDescriptionSchema,
  flex: flexSchema
}